__webpack_require__.p = "/your-phonebook/";